import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import TokenContractImage from '../../assets/images/TokenContract.png';
import MoonsContractImage from '../../assets/images/MoonsBank.png';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

class Tokenomics extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-split section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-split-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider',
      'center-content'
    );

    const splitClasses = classNames(
      'split-wrap tiles-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    const sectionHeader = {
      title: 'RXCG Tokenomics',
      paragraph: 'Detailed financial and operational overview of the RXCG token ecosystem.'
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />

            <div className={splitClasses}>

              {/* RXCG Token */}
              <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  <div className="feature-figure">
                    <img src={TokenContractImage} alt="RXCG Token Contract" width={320} height={320} />
                  </div>
                  <h4 className="mt-16 mb-8">RXCG Token</h4>
                  <p className="m-0 text-sm">
                    Contract: <a 
                      href="https://bscscan.com/token/0x7c59a57fc16eac270421b74615c4bc009ecd486d" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-link"
                    >
                      0x7c59…c486d
                    </a>
                  </p>
                </div>
              </div>

              {/* Moons Smart Contract */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="feature-figure">
                    <img src={MoonsContractImage} alt="Moons Smart Contract" width={320} height={320} />
                  </div>
                  <h4 className="mt-16 mb-8">Moons Contract</h4>
                  <p className="m-0 text-sm">
                    Contract: <a 
                      href="https://testnet.bscscan.com/token/0x1cbd9A4Fb8b7291949916d03c654E21c70A996D3" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-link"
                    >
                      0x1cbd…996D3
                    </a>
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

Tokenomics.propTypes = propTypes;
Tokenomics.defaultProps = defaultProps;

export default Tokenomics;
